const Eloquent = window.Eloquent;

/**
 * Get logged in user's profile data
 * @returns {Promise}
 */
export function getAuthedUserProfile() {
    return Eloquent.User.me();
}


/**
 * Get user data by id
 * @param {Number} id
 * @returns {Promise}
 */
export function getUserById(id) {
    return Eloquent.User.getOne(id);
}


/**
 * Get list of features authors
 * @returns {Promise}
 */
export function getFeaturedAuthors() {
    return Eloquent.User.featured();
}

/**
 * Get list of assignments (participant)
 * @returns {Promise}
 */
export function getAssignments() {
    return Eloquent.User.getAssignments();
}

/**
 * Get list of assignments (admin)
 * @returns {Promise}
 */
export function getAdminAssignments() {
    return Eloquent.User.getAdminAssignments();
}


/**
 * get assignment subgroups
 * @param {Number} id
 * @param {Number} groupId
 * @returns {Promise}
 */
export function getAdminAssignmentsUsers(id, groupId) {
    return Eloquent.User.getAdminAssignmentsUsers(id, groupId);
}


/**
 * Get list of assignments (coach)
 * @returns {Promise}
 */
export function getCoachAssignments() {
    return Eloquent.User.getCoachAssignments();
}

/**
 * Get list of all groups created by the current admin
 * @returns {Promise}
 */
export function getAdminGroups() {
    return Eloquent.User.getAdminGroups();
}


/**
 * Set logged in user's profile data
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function setUserProfile(id, data) {
    return Eloquent.User.updateOne(id, data);
}

/**
 * Set users active status
 * @param {Object} data as follows:
 * @param {Number} id
 * @param {Boolean} isActive
 * @returns {String}
 */
export async function toggleUserActive(data) {
    return Eloquent.User.toggleUserActive(data);
}

/**
 * Set users active status
 * @param {Object} data as follows:
 * @param {String} first_name
 * @param {String} last_name
 * @param {String} email
 * @param {Boolean} is_active
 * @returns {String}
 */
export function addNewCoach(data) {
    return Eloquent.User.addNewCoach(data);
}


/**
 * Get list of all Users
 * @param {Object} data - optional data to filter list
 * @returns {Promise}
 */
export function getAllUsers(data) {
    return Eloquent.User.getAll(data);
}


/**
 * Mark an author as being followed
 * @param {Number} id
 * @returns {Promise}
 */
export function followAuthor(id) {
    return Eloquent.User.follow(id);
}

/**
 * Updates user's profile data
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function UpdateUser(id, data) {
    return Eloquent.User.updateOne(id, data);
}


/**
 * Join a group
 * @param {Object} data { access_code: code }
 * @returns {Promise}
 */
export function joinGroup(data) {
    return Eloquent.User.attachGroup(data);
}



// WEBPACK FOOTER //
// ./src/api/users.js